export default __webpack_public_path__ + "static/media/pay-later.45d40b78.jpg";